import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Lightbox } from '../../../components/lightbox';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-file-list',
  templateUrl: './file-list.component.html',
  styleUrls: ['./file-list.component.scss']
})
export class FileListComponent implements OnInit, OnDestroy {
  _fileList: any[] = [];
  isShowVideoModal = false;
  videoInfo = null;

  @Input()
  set fileList(v) {
    if (v) {
      this._fileList = this.processImgThumb(v);
    }
  }

  get fileList() {
    return this._fileList;
  }

  // @Input() fileList: any[] = [];

  @Input() fileTypeList: any[] = [];
  @Input() disableSelect = false;
  @Input() showSelect = true;
  @Input() dropdownClassName = '';
  @Input() elWidth?: number;
  @Output() updateFileList = new EventEmitter();

  constructor(
    private _lightbox: Lightbox,
    private sanitizer: DomSanitizer
  ) {
  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
  }

  doEmit(event) {
    this.updateFileList.emit(this._fileList);
  }

  deleteFile(index) {
    this._fileList.splice(index, 1);
    this.updateFileList.emit(this._fileList);
  }

  openPreview(index) {
    const clicked = this._fileList[index];
    if (!clicked || clicked.fileDataType !== 'img') {
      return;
    }
    const imgArr = this._fileList.filter(i => i && i.fileDataType === 'img');
    const startIndex = imgArr.findIndex(i => i === clicked);
    const albums = imgArr.map(img => ({
      src: img.url || img.thumbUrl,
      caption: img.fileName || '',
      thumb: img.url || img.thumbUrl
    }));
    this._lightbox.open(albums, startIndex < 0 ? 0 : startIndex, { showZoom: true, showRotate: true, centerVertically: true });
  }

  processImgThumb(list) {
    for (const item of list) {
      if (item.url === undefined && item.thumbUrl === undefined) {
        if (item.originFileObj) {
          const blob = new Blob([item.originFileObj], { type: item.originFileObj?.type });
          item.url = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob));
        } else if (item instanceof File) {
          const blob = new Blob([item], { type: item.type });
          // @ts-ignore
          item.url = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob));
        }
      }
      const imgList = ['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp'];
      const videoList = ['mp4', 'mov', 'wmv', 'flv', 'avi'];
      const audioList = ['mp3', 'aac', 'wav', 'wma', 'flac'];
      const pdfList = ['pdf'];
      const wordList = ['doc', 'docx'];
      const excelList = ['xls', 'xlsx', 'csv'];
      if (item.name) {
        const nameArr = item.name?.split('.');
        const ext = (nameArr && nameArr.length > 1 ? nameArr[nameArr.length - 1] : '').toLowerCase();
        if (videoList.indexOf(ext) !== -1){
          item.fileDataType = 'video';
        }else if (imgList.indexOf(ext) !== -1){
          item.fileDataType = 'img';
        } else if (audioList.indexOf(ext) !== -1){
          item.fileDataType = 'audio';
        } else if (pdfList.indexOf(ext) !== -1){
          item.fileDataType = 'pdf';
        } else if (wordList.indexOf(ext) !== -1){
          item.fileDataType = 'word';
        } else if (excelList.indexOf(ext) !== -1){
          item.fileDataType = 'excel';
        } else {
          item.fileDataType = 'other';
        }
      } else {
        item.fileDataType = 'img';
      }
    }
    return list;
  }
  getFileIcon(type: string): string {
    const basePath = 'assets/images/';
    switch (type) {
      case 'pdf':
        return `${basePath}pdf.png`;
      case 'word':
        return `${basePath}word.png`;
      case 'excel':
        return `${basePath}excel.png`;
      default:
        return '';
    }
  }

  openPreviewVideo(file){
    this.isShowVideoModal = true;
    this.videoInfo = file;
  }

  closeVideoModal(){
    this.isShowVideoModal = false;
  }

  getDownloadName(item: any): string {
    const raw = item?.fileName || item?.name || '';
    if (!raw) {
      return '';
    }
    const dotIdx = raw.lastIndexOf('.');
    if (dotIdx <= 0) {
      return raw;
    }
    const name = raw.substring(0, dotIdx);
    const ext = raw.substring(dotIdx);
    const match = name.match(/^(.*)_\d{10,}$/);
    const cleaned = match && match[1] ? match[1] : name;
    return `${cleaned}${ext}`;
  }
}
